<app-mrp-scrolltop></app-mrp-scrolltop>
<!-- Main -->
<main id="main" class="wrapper">
  <article class="inner">
    <div class="content">
      <h1 class="visually-hidden">Advanced Parliamentary Training - Monthly Zoom Classes</h1>
      <header><h2>Advanced Zoom Class</h2></header>
      <p>Speaking. Doing. Memorizing. See <a class="class-link" (click)="scrollTo('class-dates')"><b>Class Dates </b></a>below.</p>
      <p>Repetition is how you improve.</p>

      <p>This class is a <b>RECURRING</b> monthly zoom class designed specifically to practice and review in order to improve profiiency.</p>

      <p>Advanced classes are also customized based on class requests to address current situations participants are experiencing.</p>

      <p><b>Every 3rd Wednesday at 7PM - 8:30PM</b> </p>

      <!-- <p><b>PRICE:</b> $40 per month recurring subscription.</p>
      <p><b>INCLUDES:</b> Access to one other Zoom class per month during life of subscription.</p>
      <p><b>CANCELLATION:</b> Cancellation is available at any time via the Member Portal.</p>
      -->

      <div class="table-wrapper">
        <table>
          <tbody>
            <tr>
              <td><b>PRICE:</b></td>
              <td><b>$40</b> per month recurring subscription.</td>
            </tr>
            <tr>
              <td><b>INCLUDES:</b></td>
              <td>Access to one other Zoom class per month during life of subscription.</td>
            </tr>
            <tr>
              <td><b>CANCELLATION:</b></td>
              <td>Cancellation is available at any time via the Member Portal.</td>
            </tr>
          </tbody>
        </table>
      </div>


      <p><i>NOTE: Please login 10 minutes early for registration.</i></p>
      <!-- Table -->
      <h3>Advanced Topics</h3>

      <div class="table-wrapper">
        <table>
          <thead>
            <tr><th>Topic </th>
            <th>Description</th>

          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Disciplinary Measures</td>
          </tr>
          <tr>
            <td>2</td>
            <td>Difficult Situtions</td>
          </tr>
          <tr>
            <td>3</td>
            <td>Debate Practice  </td>
          </tr>
          <tr>
            <td>4</td>
            <td>Rules Practice  </td>
          </tr>
          <tr>
            <td>5</td>
            <td>Complex Motion Practice  </td>
          </tr>

        </tbody>

      </table>
    </div>



  </div>
</article>
</main>


<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->

<!-- Class Dates Section -->
<section id="class-dates" class="wrapper">
  <article class="inner">
    <div class="content">

      <header><h2>Class Dates</h2></header>


      @if (!isLoggedIn()) {
        <div>
          <!-- Must Register to SignUp for Advanced Zoom Class. -->
          <div class="col-12">
            <ul class="actions">
              <li><input class="requestbtn" type="submit" value="Membership SignUp" routerLink="/register" ></li>
            </ul>
          </div>
        </div>
      }



      @if (isLoggedIn()) {
        <div>
          @if (isLoading) {
            <div >
              <div class="spinner-container">
                <div class="spinner"></div>
              </div>
              <h5>Retrieving data...</h5>
            </div>
          }
          @if (!isLoading) {
            <div>
              <div class="classlist-container">
                <table class="classes-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Date</th>
                      <th>Purchase</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (class of classes; track class) {
                      <tr>
                        <td (click)="gotoClass(class.item_CODE)">{{ class.productTitle }}</td>
                        <td>{{ class.eventDate }}</td>
                        <td>
                          <!-- <button class="purchase-btn" (click)="initiateCheckout(class.priceID, 'subscription')" [disabled]="isInitiatingCheckout">
                          <span *ngIf="!isInitiatingCheckout">Register</span>
                          <span *ngIf="isInitiatingCheckout" class="checkout-spinner"></span>
                        </button> -->
                        <button class="purchase-btn" (click)="gotoClass(class.item_CODE)">
                          Register
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </div>
    }

  </div>
</article>
</section>


<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->
<!-- ---------------------------------------------------------------------------------------->

<!-- Main -->
<section id="main" class="wrapper">
  <article class="inner">
    <div class="content">

      <!-- Elements -->
      <div class="row">
        <div class="col-12 col-12-medium">



          <div class="col-12 col-12-medium">

            <h3>Testimonials</h3>
            <div class="box">
              <blockquote>"The Zoom made it very convenient for me. Thank you. And thank you for taking my questions." -Allen</blockquote>
              <blockquote>"If it wasn't for the Zoom class I wouldn't have been trained in time. And you covered it really well! Thank you!." -Patricia</blockquote>
            </div>
          </div>

        </div>
      </div>
    </div>
  </article>
</section>

<app-footer></app-footer>



